let SupportedChainId, SupportedTokens, SUPPORTED_RPC_URLS, CHAIN_INFO, SupportedChainIdBySymbol, USDT_CONTRACT_ADDRESS, BUSD_CONTRACT_ADDRESS, AVAX_CONTRACT_ADDRESS, SOL_SPL_CONTRACT_ADDRESS, SPECIAL_CONTRACT_ADDRESS, SUPPORTED_RPC_NODES;

if (process.env.REACT_APP_NODE_ENV != "production") {
	SupportedChainId = {
		ETHEREUM: 11155111,
		MATIC: 84432,
		BINANCE: 97,
		BITCOIN: 10001,
		AVAX: 43113,
		SOLANA: 102,
		RIPPLE: 2,
		POLYGON_AMOY: 84432,
		SHASTA: 1,
	};

	SupportedTokens = {
		BNB: 97,
		BUSD: 97,
		ETH: 11155111,
		USDT: 11155111,
		BITCOIN: 10001,
		AVAX: 43113,
		MATIC: 84432,
		SOL: 102,
		XRP: 2,
		POLYGON_AMOY: 84432,
		SHASTA: 1,
	};

	SUPPORTED_RPC_URLS = {
		[SupportedChainId.ETHEREUM]: "https://ethereum-sepolia-rpc.publicnode.com",
		[SupportedChainId.MATIC]: "https://rpc-amoy.polygon.technology",
		[SupportedChainId.BINANCE]: "https://data-seed-prebsc-1-s1.binance.org:8545/",
		[SupportedChainId.BITCOIN]: "https://data-seed-prebsc-1-s1.bitcoin.org:8545/",
		[SupportedChainId.AVAX]: "https://api.avax-test.network/ext/bc/C/rpc",
		[SupportedChainId.SOLANA]: "https://api.testnet.solana.com",
		[SupportedChainId.RIPPLE]: "https://s.altnet.rippletest.net:51234",
		[SupportedChainId.POLYGON_AMOY]: "https://rpc-amoy.polygon.technology",
		[SupportedChainId.SHASTA]: "https://nile.trongrid.io",
		[SupportedChainId.TRX]: "https://api.shasta.trongrid.io",
	};

	SUPPORTED_RPC_NODES = {
		[SupportedChainId.ETHEREUM]: "https://api-sepolia.etherscan.io",
		[SupportedChainId.MATIC]: "https://api-amoy.polygonscan.com",
		[SupportedChainId.BINANCE]: "https://api-testnet.bscscan.com",
		[SupportedChainId.SOLANA]: "https://api.devnet.solana.com",
		[SupportedChainId.POLYGON_AMOY]: "https://api-amoy.polygonscan.com",
		[SupportedChainId.NILE]: "https://nile.trongrid.io",
		[SupportedChainId.TRX]: "https://api.shasta.trongrid.io",
	};

	CHAIN_INFO = {
		[SupportedChainId.ETHEREUM]: {
			explorer: "https://sepolia.etherscan.io/",
			label: "Sepolia test network",
			nativeCurrency: { name: "Sepolia", symbol: "ETH", decimals: 18 },
			apiId: "ethereum",
			sellerContractAddress: "0xA6A27Eb6DCD6a9849dA0E45Dd3d97Ce128A0D63B",
		},
		[SupportedChainId.MATIC]: {
			explorer: "https://amoy.polygonscan.com/",
			label: "Polygon Testnet",
			nativeCurrency: { name: "Polygon Amoy", symbol: "MATIC", decimals: 18 },
			apiId: "polygon-amoy",
		},
		[SupportedChainId.BINANCE]: {
			explorer: "https://testnet.bscscan.com/",
			label: "Binance Testnet",
			nativeCurrency: { name: "Binance", symbol: "BNB", decimals: 18 },
			apiId: "binancecoin",
			sellerContractAddress: "0x460594669717dcB228C33156386badeAC942a376",
		},
		[SupportedChainId.BITCOIN]: {
			explorer: "https://testnet.bscscan.com/",
			label: "Bitcoin",
			nativeCurrency: { name: "Bitcoin", symbol: "BCHT", decimals: 18 },
			apiId: "bitcoin",
			sellerContractAddress: "0x460594669717dcB228C33156386badeAC942a376",
		},
		[SupportedChainId.AVAX]: {
			explorer: "https://testnet.snowtrace.io/",
			label: "Avax",
			nativeCurrency: { name: "Avax", symbol: "AVAX", decimals: 18 },
			apiId: "avalanche-2",
			sellerContractAddress: "0x460594669717dcB228C33156386badeAC942a376",
		},
		[SupportedChainId.SOLANA]: {
			explorer: "https://solscan.io/",
			label: "Solana",
			nativeCurrency: { name: "Solana", symbol: "SOLANA", decimals: 18 },
			apiId: "solana",
			sellerContractAddress: "0x460594669717dcB228C33156386badeAC942a376",
		},
		[SupportedChainId.RIPPLE]: {
			explorer: "https://test.bithomp.com/explorer/",
			label: "Ripple Testnet",
			nativeCurrency: { name: "Ripple", symbol: "XRP", decimals: 6 },
			apiId: "ripple",
			sellerContractAddress: "Replace_with_ripple_contract_address",
		},
		[SupportedChainId.POLYGON_AMOY]: {
			explorer: "https://amoy.polygonscan.com/",
			label: "Polygon Amoy Testnet",
			nativeCurrency: { name: "Polygon Amoy", symbol: "AMOY", decimals: 18 },
			apiId: "polygon-amoy",
			// sellerContractAddress: "0x460594669717dcB228C33156386badeAC942a376"
		},
		[SupportedChainId.SHASTA]: {
			explorer: "https://shasta.tronscan.org/",
			label: "Shasta Testnet",
			nativeCurrency: { name: "Shasta", symbol: "TRX", decimals: 6 },
			apiId: "tron",
			// sellerContractAddress: "0x460594669717dcB228C33156386badeAC942a376"
		},
	};

	SupportedChainIdBySymbol = {
		RinkebyETH: 5,
		MATIC: 84432,
		BNB: 97,
		BTC: 10001,
		AVAX: 43113,
		SOLANA: 102,
		XRP: 2,
		POLYGON_AMOY: 84432,
		SHASTA: 1,
	};

	USDT_CONTRACT_ADDRESS = "0x7169D38820dfd117C3FA1f22a697dBA58d90BA06";
	AVAX_CONTRACT_ADDRESS = "0xCaB8632DE9B8cEb4c4777b3015A411Bf842B2530";

	SOL_SPL_CONTRACT_ADDRESS = {
		USDC: "Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr",
		USDT: "Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr"
	};

	SPECIAL_CONTRACT_ADDRESS = {
		ETH: {
			USDC: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
			// USDT: "0xA1d7f71cbBb361A77820279958BAC38fC3667c1a",
			USDT: "0x7169D38820dfd117C3FA1f22a697dBA58d90BA06",
			LINK: "0xb227f007804c16546Bd054dfED2E7A1fD5437678",
			MATIC: "0x8D38d6Ffa17FFD6dA49D4b53B6f0DFc8D291E867",
		},
		MATIC: {
			USDC: "0x702207d9c124c86c85A97222Cde98476f987ddaE",
			USDT: "0x702207d9c124c86c85A97222Cde98476f987ddaE",
			DAI: "0xb2df85a09cAB3a391Fd9ade76342583A0d4B75ce",
		},
		POLYGON_AMOY: {
			USDC: "0x702207d9c124c86c85A97222Cde98476f987ddaE",
			USDT: "0x702207d9c124c86c85A97222Cde98476f987ddaE",
			DAI: "0xb2df85a09cAB3a391Fd9ade76342583A0d4B75ce",
		},
		BNB: {
			USDT: "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd",
			USDC: "0xfbe87897c07Cc64b6FFc04257672854b90e5B17b",
		},
		SHASTA: {
			USDT: "TG3XXyExBkPp9nzdajDZsozEu4BkaSJozs",
			USDC: "TSdZwNqpHofzP6BsBKGQUWdBeJphLmF6id",
		},
		TRX: {
			USDT: "TG3XXyExBkPp9nzdajDZsozEu4BkaSJozs",
			USDC: "TSdZwNqpHofzP6BsBKGQUWdBeJphLmF6id",
		}
	}

} else {

	SupportedChainId = {
		ETHEREUM: 1,
		POLYGON: 137,
		BINANCE: 56,
		BITCOIN: 10001, // Not sure to use this chain
		AVAX: 43113,
		SOLANA: 101,
		TRX: 1,
	};

	SupportedTokens = {
		BNB: 56,
		ETH: 1,
		USDT: 1,
		BITCOIN: 10001, // Not sure to use this chain
		AVAX: 43113,
		MATIC: 137,
		SOL: 101,
		TRX: 1,
	};

	SUPPORTED_RPC_URLS = {
		[SupportedChainId.ETHEREUM]: "https://rpc.ankr.com/eth",
		[SupportedChainId.POLYGON]: "https://polygon.llamarpc.com",
		[SupportedChainId.BINANCE]: "https://bsc-rpc.publicnode.com	",
		[SupportedChainId.BITCOIN]: "https://data-seed-prebsc-1-s1.bitcoin.org:8545/",
		[SupportedChainId.AVAX]: "https://api.avax-test.network/ext/bc/C/rpc",
		[SupportedChainId.SOLANA]: "https://api.mainnet-beta.solana.com",
		[SupportedChainId.TRX]: "https://api.trongrid.io"
	};

	SUPPORTED_RPC_NODES = {
		[SupportedChainId.ETHEREUM]: "https://api.etherscan.io",  
		[SupportedChainId.MATIC]: "https://api.polygonscan.com", 
		[SupportedChainId.BINANCE]: "https://api.bscscan.com",  
		[SupportedChainId.SOLANA]: "https://api.mainnet-beta.solana.com", 
		[SupportedChainId.POLYGON_AMOY]: "https://api.polygonscan.com", 
		[SupportedChainId.TRX]: "https://api.trongrid.io",
	};
	
	CHAIN_INFO = {
		[SupportedChainId.ETHEREUM]: {
			explorer: "https://etherscan.io/",
			label: "Ethereum MainNet",
			nativeCurrency: { name: "Ethereum MainNet", symbol: "ETH", decimals: 18 },
			apiId: "ethereum",
			sellerContractAddress: "0xA6A27Eb6DCD6a9849dA0E45Dd3d97Ce128A0D63B",
		},
		[SupportedChainId.POLYGON]: {
			explorer: "https://polygonscan.com/",
			label: "Polygon MainNet",
			nativeCurrency: { name: "Polygon Matic", symbol: "MATIC", decimals: 18 },
			apiId: "matic-network",
			sellerContractAddress: "0xb712f61bBE45C1313B3F30082760dc40B9dd7D47",
		},
		[SupportedChainId.BINANCE]: {
			explorer: "https://bscscan.com/",
			label: "Binance Mainnet",
			nativeCurrency: { name: "Binance", symbol: "BNB", decimals: 18 },
			apiId: "binancecoin",
			sellerContractAddress: "0x460594669717dcB228C33156386badeAC942a376",
		},
		[SupportedChainId.BITCOIN]: {
			explorer: "https://bscscan.com/",
			label: "Bitcoin",
			nativeCurrency: { name: "Bitcoin", symbol: "BCHT", decimals: 18 },
			apiId: "bitcoin",
			sellerContractAddress: "0x460594669717dcB228C33156386badeAC942a376",
		},
		[SupportedChainId.AVAX]: {
			explorer: "https://snowtrace.io/",
			label: "Avax",
			nativeCurrency: { name: "Avax", symbol: "AVAX", decimals: 18 },
			apiId: "avalanche-2",
			sellerContractAddress: "0x460594669717dcB228C33156386badeAC942a376",
		},
		[SupportedChainId.SOLANA]: {
			explorer: "https://solscan.io/",
			label: "Solana",
			nativeCurrency: { name: "Solana", symbol: "SOLANA", decimals: 18 },
			apiId: "solana",
			sellerContractAddress: "0x460594669717dcB228C33156386badeAC942a376",
		},
		[SupportedChainId.TRX]: {
			explorer: "https://tronscan.org/",
			label: "Tron",
			nativeCurrency: { name: "Tron", symbol: "TRX", decimals: 18 },
			apiId: "tron",
		},
	};

	SupportedChainIdBySymbol = {
		RinkebyETH: 5,
		MATIC: 80001,
		BNB: 97,
		BTC: 10001,
		AVAX: 43113,
		SOLANA: 101,
		TRX: 1,
	};
	USDT_CONTRACT_ADDRESS = "0xdAC17F958D2ee523a2206206994597C13D831ec7";
	AVAX_CONTRACT_ADDRESS = "0xCaB8632DE9B8cEb4c4777b3015A411Bf842B2530";

	SOL_SPL_CONTRACT_ADDRESS = {
		USDC: "Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr",
		USDT: "Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr"
	};

	SPECIAL_CONTRACT_ADDRESS = {
		ETH: {
			USDC: "0x6c6bc977e13df9b0de53b251522280bb72383700",
			USDT: "0xdac17f958d2ee523a2206206994597c13d831ec7",
		},
		POLYGON_AMOY: {
			USDC: "0x41E94Eb019C0762f9Bfcf9Fb1E58725BfB0e7582",
			USDT: "0x513573F53d3865607bEB921F391d4701AD0e5110",
			DAI: "0xb2df85a09cAB3a391Fd9ade76342583A0d4B75ce",
		},
		BNB: {
			USDT: "0x2B90E061a517dB2BbD7E39Ef7F733Fd234B494CA",
		},
		TRX: {
			USDT: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
			USDC: "TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8",
		}
	}

}

export {
	SupportedChainId,
	SupportedTokens,
	SUPPORTED_RPC_URLS,
	CHAIN_INFO,
	SupportedChainIdBySymbol,
	USDT_CONTRACT_ADDRESS,
	AVAX_CONTRACT_ADDRESS,
	SPECIAL_CONTRACT_ADDRESS,
	SOL_SPL_CONTRACT_ADDRESS,
	SUPPORTED_RPC_NODES,
};

